module.exports = __webpack_public_path__ + "img/rounded-plus.3cdd0efc.svg";